import { Button, DatePicker, Drawer, Form, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { returnAsset } from "../../../redux/rtk/features/assets/assetsSlice";
import { loadAllStaff } from "../../../redux/rtk/features/user/userSlice";

const ReturnAssetPopup = ({ assetData }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [loader, setLoader] = useState(false);
    const [open, setOpen] = useState(false);
    const users = useSelector((state) => state.users?.list);

    useEffect(() => {
        dispatch(loadAllStaff({ status: true }));
    }, []);

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
        form.resetFields();
    };

    const onFinish = async (values) => {
        const formData = {
            ...values,
            returnDate: values.returnDate ? values.returnDate.toISOString() : null,
            status: true
        };

        try {
            setLoader(true);
            await dispatch(returnAsset({ 
                assetId: assetData.id, 
                values: formData 
            }));
			form.resetFields();
            onClose();
        } catch (error) {
            toast.error("Failed to return asset");
        } finally {
            setLoader(false);
        }
    };

    const onFinishFailed = (errorInfo) => {
        toast.warning("Please complete the required fields");
        setLoader(false);
    };

    return (
        <>
            <Button onClick={showDrawer} type='primary' className="bg-red-500">
                Return Asset
            </Button>
            <Drawer
                width={720}
                title='Return Asset'
                placement='right'
                onClose={onClose}
                open={open}
            >
                <Form
                    form={form}
                    layout='vertical'
                    initialValues={{ 
                        returnDate: dayjs(),
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Return To "
                        name="returnToUserId"
                        rules={[
                            {
                                required: true,
                                message: "Please select a user!",
                            },
                        ]}
                    >
                        <Select
                            placeholder="Return To"
                            showSearch
                            allowClear
                            optionFilterProp="children"
                        >
                            {users?.map(user => (
                                <Select.Option key={user.id} value={user.id}>
                                    {user.firstName} {user.lastName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label='Return Date'
                        name='returnDate'
                        rules={[
                            {
                                required: true,
                                message: "Please select return date!",
                            },
                        ]}
                    >
                        <DatePicker format={"DD-MM-YYYY"} />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type='primary'
                            htmlType='submit'
                            loading={loader}
                            block
                        >
                            Return Asset
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </>
    );
};

export default ReturnAssetPopup;